import { render } from "./FieldTextBlock.vue?vue&type=template&id=6c3ac494"
import script from "./FieldTextBlock.vue?vue&type=script&lang=js"
export * from "./FieldTextBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__